import styled from '@emotion/styled';
import { Divider, Grid, Select, Typography } from '@mui/material';
import { Box, css } from '@mui/system';
import Button from 'components/atoms/Button';
import { colors } from 'theme/colors';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export const StyledTableCard = styled(Grid)`
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  overflow: hidden;
  margin-top: 8px;
  background-color: ${colors.gray100};
  padding: 8px 0;
  width: 100%;
`;
export const StyledTableCardItem = styled(Grid)`
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  gap: 4px;
`;
export const StyledDetail = styled(Grid)`
  background: ${colors.gray100};
  opacity: 1;
  border-radius: 4px;
  border-width: 1px;
  padding: 20px;
  border: 1px solid ${colors.gray200};
  row-gap: 16px;
  column-spacing: 16px;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  border: 1px solid ${colors.primary500} !important;
  height: 40px;
  padding: 8px 13px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

export const StyledSortButtonsWrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding: 0px;
  background-color: ${colors.white};
`;

interface IStyledSortButton {
  selected: boolean;
}

export const StyledSortButton = styled(Button)<IStyledSortButton>`
  flex: 1;
  height: 40px;
  background-color: ${colors.white};
  border-radius: 0;
  color: ${colors.primary900};
  ${({ selected }: IStyledSortButton) => css`
    font-weight: ${selected ? '600px' : '400px'};
    border-bottom: ${
      selected ? `4px solid ${colors.primary900}` : `1px solid ${colors.primary900}`
    };
    &:hover {
      background: ${colors.white};
      box-shadow: none;
    }
    &:focus {
      background: ${colors.white};
    }
  `};
`;
interface IStyledIconWrapper {
  error?: boolean;
}

export const StyledIconWrapper = styled.div<IStyledIconWrapper>`
  width: 24px;
  height: 24px;
  padding: 3.6px;
  border-radius: 4px;
  display: flex;
  justify-content: start;
  align-items: center;
  ${({ error }: IStyledIconWrapper) => css`
    background-color: ${error ? colors.error50 : colors.success50};
  `};
`;

export const StyledValueFormHeader = styled(Typography)`
  background: ${colors.primary900};
  color: ${colors.white};
  height: min-content;
  font-size: 20px;
  border-radius: 4px;
  padding: 10px 20px;
  margin-left: -5px;
`;

export const StyledDivider = styled(Divider)(() => ({
  height: '1px',
  width: '100%',
  backgroundColor: colors.gray200,
}));

const ToBeStyledTooltip = ({ className, ...props }: TooltipProps) => (
  <Tooltip enterTouchDelay={0} {...props} classes={{ tooltip: className }} />
);

export const StyledTooltip = styled(ToBeStyledTooltip)(() => ({
  backgroundColor: colors.white,
  color: colors.primary500,
  fontSize: '14px',
  gap: '4px',
  border: `1px solid ${colors.primary500}`,
  borderRadius: '4px',
}));

export const NoComments = styled.div`
  height: 60px;
  border-radius: 4px;
  border: 1px solid ${colors.gray200};
  background: ${colors.gray100};
  padding: 17px;
  color: ${colors.gray400};
  font-style: italic;
  font-size: 14px;
  text-align: center;
`;
